import ExplosivePrecursorFormValidation from '../explosives/ExplosivePrecursorFormValidation';
import MachineAgrementFormValidation from '../machine/MachineAgrementFormValidation';
import DistillateFormValidation from '../distillate/DistillateFormValidation';
import FormDocuments from './FormDocuments';

/**
 * Shared class for Agreement Step Navigation
 * Stepping through the agreement process
 * when Validation is validated and valid
 */
export default class AgreementSteps {
    /**
     * Selecting validation methods depending on input parameter
     * @param {*} agreementType
     */
    constructor(agreementType) {
        switch (agreementType) {
            case 'machines':
                this.validation = new MachineAgrementFormValidation();
                break;

            case 'explosives':
                this.validation = new ExplosivePrecursorFormValidation();
                break;

            case 'distillate':
                this.validation = new DistillateFormValidation();
                break;
        }

        // Set navigation object
        this.steps = this.setStepNavigation();

        // Event Listerners
        this.initEventListerners();

        this.FormDocuments = new FormDocuments();
    }

    /**
     * Set the Steps and views static.
     * The step values is part of a css class or id in the razor view.
     * For example: .step2, showStep2 or #Step2Next and #Step2Back
     * @return
     */
    setStepNavigation() {
        const formPage = 1;
        const selectReceiverPage = 2;
        const reviewDataPage = 3;

        const siteType = document.querySelector('#isInternal').value === 'true' ? true : false;

        return {
            init: {
                elements: formPage,
                selector: formPage,
                view: siteType ? selectReceiverPage : reviewDataPage,
            },
            proceed: {
                elements: selectReceiverPage,
                selector: selectReceiverPage,
                view: reviewDataPage,
            },
            back: {
                selector1: selectReceiverPage,
                view1: formPage,
                selctor2: reviewDataPage,
                view2: siteType ? selectReceiverPage : formPage,
            },
        };
    }

    /**
     * Event Listerner
     * @return void
     */
    initEventListerners() {
        // Step 1 - Form
        for (const formElements of document.querySelectorAll(`.step${this.steps.init.elements}`)) {
            document
                .getElementById(formElements.getAttribute('id'))
                .addEventListener('change', () => {
                    this.validation.checkForm('form');
                });
        }
        // Step to reciever
        document
            .querySelector(`#Step${this.steps.init.selector}Next`)
            .addEventListener('click', () => {
                this.stepsViews(`showStep${this.steps.init.view}`);
            });

        // Step 2 - Reciever
        for (const formElements of document.querySelectorAll(
            `.step${this.steps.proceed.elements}`
        )) {
            document
                .getElementById(formElements.getAttribute('id'))
                .addEventListener('change', () => {
                    this.validation.checkForm('reciever');
                });
        }

        // Step to Review & Sign
        document
            .querySelector(`#Step${this.steps.proceed.selector}Next`)
            .addEventListener('click', () => {
                this.stepsViews(`showStep${this.steps.proceed.view}`);
            });

        // Back from Reciever
        document
            .querySelector(`#Step${this.steps.back.selector1}Back`)
            .addEventListener('click', () => {
                this.stepsViews(`showStep${this.steps.back.view1}`);
            });

        // Back from Review & Sign
        document
            .querySelector(`#Step${this.steps.back.selctor2}Back`)
            .addEventListener('click', () => {
                this.stepsViews(`showStep${this.steps.back.view2}`);
            });
    }

    /**
     * Change views
     * @param {*} steps
     * @return void
     */
    stepsViews(steps) {
        let elements = document.querySelectorAll('.steps');
        elements.forEach((elements) => {
            elements.classList.add('hidden');
        });

        switch (steps) {
            case 'showStep1':
                document.getElementById('step1View').classList.remove('hidden');
                break;
            case 'showStep2':
                document.getElementById('step2View').classList.remove('hidden');
                break;
            case 'showStep3':
                document.getElementById('step3View').classList.remove('hidden');
                // Update document link when showing Step 3
                if (document.getElementsByClassName('machine-agreement').length > 0) {
                    this.FormDocuments.updateAgreementDocument();
                }
                break;
            case 'showStep4':
                document.getElementById('step4View').classList.remove('hidden');
                break;
        }
    }
}
